// 企业    活动
import axios from "../../../../untils/request.js";
// 企业  文件库管理    资料下载

// 文件库-在职离职员工列表
export async function employeeViewInfoList(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/company/employeeViewInfoList",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//文件库-查询员工附件信息
export async function viewEmployeeContractsAndResumes(data) {
  const res = await axios({
    method: "post",
    url: "/info/company/viewEmployeeContractsAndResumes",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//文件库-查询公司在职和离职人数
export async function getCompanyEmployeeCount(data) {
  const res = await axios({
    method: "post",
    url: "/info/company/getCompanyEmployeeCount",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//首次添加信用评价时回显员工基本信息以及附件
export async function getCompanyEmployeeInfo(data) {
  const res = await axios({
    method: "post",
    url: "/info/company/getCompanyEmployeeInfo",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//编辑员工简历、合同 或者上传/更换员工信用评价申请
export async function editEmployeeAttachment(data) {
  const res = await axios({
    method: "post",
    url: "/info/company/editEmployeeAttachment",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//公司文件库中查看员工信用评价（正常查看/重新提交回显）
export async function lookEmployeeCreditEvaluationByEmployeeId(data) {
  const res = await axios({
    method: "post",
    url: "/info/user/lookEmployeeCreditEvaluationByEmployeeId",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//公司文件库新增员工信用评价
export async function addCreditEvaluation(data) {
  const res = await axios({
    method: "post",
    url: "/info/user/addCreditEvaluation",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//追加信用评价
export async function appendCreditEvaluation(data) {
  const res = await axios({
    method: "post",
    url: "/info/user/appendCreditEvaluation",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//取消追加审批
export async function cancelAppendAudit(data) {
  const res = await axios({
    method: "post",
    url: "/info/user/cancelAppendAudit",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//清空员工附件表
export async function deleteEmployeeAttachment(data) {
  const res = await axios({
    method: "post",
    url: "/info/company/deleteEmployeeAttachment",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//获取系统文件库-文件类型
export async function getFileType(data) {
  const res = await axios({
    method: "post",
    url: "/sys/fileLibrary/getFileTypeForCompany",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//根据文件类型获取文档列表
export async function getFileList(data, currentPage, pageSize, val) {
  const res = await axios({
    method: "post",
    url: "/sys/fileLibrary/getFileListForCompany?fileType=" + val,
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//新增文件到文件库中
export async function insertFileForLib(data) {
  const res = await axios({
    method: "post",
    url: "/sys/fileLibrary/insertFileForLib",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//删除文件库中文件
export async function deleteLibFile(data) {
  const res = await axios({
    method: "post",
    url: "/sys/fileLibrary/deleteLibFile",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//根据条件检索 信用评价库
export async function searchUserCreditEvaluation(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/searchUserCreditEvaluation",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//公司管理员在信用库查看信用评价
export async function lookUserCreditEvaluationByCreditId(data) {
  const res = await axios({
    method: "post",
    url: "/info/user/lookUserCreditEvaluationByCreditId",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
